// Reexport the native module. On web, it will be resolved to AppPreferencesModule.web.ts
// and on native platforms to AppPreferencesModule.ts
export { default } from '@/modules/app-preferences/src/AppPreferencesModule'
export * from '@/modules/app-preferences/src/AppPreferences.types'
